import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { ValueReferenceCESComponent } from '../crud-ces/crud-ces.component';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { ValueReferenceService } from '../crud-service';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { FormDataCreate } from '../crud-ces/formDataBuild/form-data-create';
import { IValueReference } from 'src/app/domain/registration/models/IValueReference';

@Component({
  selector: 'app-value-references-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [ValueReferenceService],
})
export class ValueReferenceCrudIndex
  extends AbstractCrudIndex<IValueReference>
  implements ITableResponsive
{
  override title = 'VALORES DE REFERENCIA';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  constructor(
    public override dialog: MatDialog,
    public override service: ValueReferenceService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe((dataWithPagination: any) => {
      const [data, length] = dataWithPagination;
      this.length = length;

      this.dataSource = new MatTableDataSource<any>(
        data.map((item: any) => {
          item['type'] = (item.type);
          item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
          return item;
        })
      );
    });
  }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: ValueReferenceCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: ValueReferenceCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      callBack: async (data: any) => {
        if (data?.element) {
          this.service
          .createWithFormData(
            await new FormDataCreate().build({
              ...data.element,
              name: data.element.name,
            })
          )
          .subscribe((data: any) => {
            this.loadList();
            this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
          },
          (error) => {
            this.openNew(data.element);
          });
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: ValueReferenceCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      callBack: async (data: any) => {
        if (data?.element?.id) {
          this.service
            .updateWithFormData(
              data.element.id,
              await new FormDataCreate().build({
                ...data.element,
                name: data.element.name,
              })
            )
            .subscribe({
              next: () => {
                this.loadList();
                this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
              },
              error: (error) => {
                this.openEdit(data.element);
              },
            });
        }
  
        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }
  
        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }
  
}
